/* eslint-disable react/jsx-indent */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { BsFilter } from 'react-icons/bs';
import { MdDelete, MdRemoveRedEye } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { Prompt } from 'react-router-dom';

import { CircularProgress, Radio } from '@material-ui/core';
import { FormHandles, SubmitHandler } from '@unform/core';
import { Form } from '@unform/web';
import { Formik } from 'formik';
import { Location } from 'history';
import moment from 'moment';
import * as Yup from 'yup';

import DateRange from '~/components/DateRange';
import FilterChips from '~/components/FilterChips';
import Select from '~/components/Form/Select';
import DataListInput from '~/components/Formik/InputSearch/DataListInput';
import InputSearchDebounce, {
  SearchInputImperativeProps,
} from '~/components/InputSearchDebounce';
import Modal from '~/components/Modal';
import PageTitle from '~/components/PageTitle';
import Sidesheet from '~/components/Sidesheet';
import PaginatedTable from '~/components/Table/PaginatedTable';
import { useAuth } from '~/hooks/auth';
import { useNavigation } from '~/hooks/Navigation';
import { IState } from '~/store';
import {
  getProcessesExecutionsRequest,
  getProcessesExecutionsCountRequest,
  cancelProcessExecutionsRequest,
  getProcessesRequest,
} from '~/store/modules/processes/actions';
import {
  IProcessesHistory,
  IProcessesInstance,
} from '~/store/modules/processes/types';
import { getActivatedUsersRequest } from '~/store/modules/users/actions';
import { permissions, profiles } from '~/types/constants';
import { ObjectLiteral } from '~/types/generics';

import ExecutionDetails from './ExecutionDetails';
import {
  Container,
  FormControl,
  FormControlLabel,
  RadioGroup,
  CustomButton,
  Wrapper,
  FilterWrapper,
  FilterButton,
  SidesheetCustomStyle,
  FilterTitle,
  SubmitFilterButton,
  FilterContainer,
} from './styles';

type ProcessesType = 'inProgress' | 'completed' | 'deleted';

interface FormTableData {
  processDefinitionNameLike?: string[];
  registradoPor?: string[];
  startTime?: string[];
  endTime?: string[];
}

type FilterParams =
  | 'registradoPor'
  | 'processDefinitionNameLike'
  | 'startTime'
  | 'endTime';

moment.locale('pt-br');

const DATA_LIST_ID = 'wedo_justificativaDoCancelamento';

const ProcessesExecutions = () => {
  const [resetPage, setResetPage] = useState<boolean>(false);
  const [customLimit, setCustomLimit] = useState<number>(15);
  const [processesType, setProcessesType] = useState<ProcessesType>(
    'inProgress',
  );
  const [selectedProcesses, setSelectedProcesses] = useState<
    IProcessesInstance[]
  >([]);

  const {
    canNavigate,
    setLocation,
    setConfirmationModal,
    setCanNavigate,
    confirmAndNavigate,
  } = useNavigation({
    customHeaderMessage: 'Os filtros serão descartados.',
  });

  const activeUsers = useSelector(
    (state: IState) => state.users.activatedUsers,
  );

  const [filterParams, setFilterParams] = useState<FormTableData>({});

  const [totalProcesses, setTotalProcesses] = useState<number>(0);
  const [modalProcessFilter, setModalProcessFilter] = useState<boolean>(false);

  const [modalProcessDetail, setModalProcessDetail] = useState<boolean>(false);
  const [modalCancelProcess, setModalCancelProcess] = useState<boolean>(false);
  const [selectedProcess, setSelectedProcess] = useState<
    IProcessesInstance | IProcessesHistory | null | undefined
  >(null);
  const [search, setSearch] = useState<string>('');

  const [showCheckBox, setShowCheckBox] = useState<boolean>(false);

  const { user, checkProfile } = useAuth();

  const loadingProcessCancelation = useSelector(
    (state: IState) => state.processes.loadingProcessCancelation,
  );

  const processesExecutions = useSelector(
    (state: IState) => state.processes.processesExecutions,
  );

  const processCanceled = useSelector(
    (state: IState) => state.processes.processCanceled,
  );

  const processesDefinition = useSelector(
    (state: IState) => state.processes.processes,
  );

  const loadingProcessesExecutions = useSelector(
    (state: IState) => state.processes.loadingProcessesExecutions,
  );

  const processesExecutionsInProgressTotal = useSelector(
    (state: IState) => state.processes.processesExecutionsInProgressTotal,
  );
  const processesExecutionsCompletedTotal = useSelector(
    (state: IState) => state.processes.processesExecutionsCompletedTotal,
  );
  const processesExecutionsTerminatedTotal = useSelector(
    (state: IState) => state.processes.processesExecutionsTerminatedTotal,
  );

  const dispatch = useDispatch();
  const formTableRef = useRef<FormHandles>(null);
  const searchInputRef = useRef<SearchInputImperativeProps>(null);

  const loadProcessesExecutions = useCallback(
    (params: ObjectLiteral) => {
      dispatch(getProcessesExecutionsRequest(params));
    },
    [dispatch],
  );

  const handleFilterParams = () => {
    const data = formTableRef.current?.getData() as FormTableData;
    const newFilterParams: FormTableData = {};

    if (
      data?.processDefinitionNameLike &&
      data.processDefinitionNameLike?.length > 0
    ) {
      Object.assign(newFilterParams, {
        processDefinitionNameLike: data.processDefinitionNameLike,
      });
    }
    if (data?.registradoPor && data.registradoPor?.length > 0) {
      Object.assign(newFilterParams, {
        registradoPor: data.registradoPor,
      });
    }
    if (data?.startTime && data.startTime[0] && data.startTime[1]) {
      Object.assign(newFilterParams, {
        startTime: data.startTime,
      });
    }
    if (data?.endTime && data.endTime[0] && data.endTime[1]) {
      Object.assign(newFilterParams, {
        endTime: data.endTime,
      });
    }

    setFilterParams(newFilterParams);
  };

  const handleFilterTableExecutions = useCallback(
    (params: { page: number; limit: number }) => {
      const executionsOrSolicitations = search;
      const { page, limit } = params;

      const formattedParams = {
        processesType,
        page: page || 1,
        limit,
        executionsOrSolicitations,
        registradoPor:
          filterParams?.registradoPor?.map((registrado) => `"${registrado}"`) ??
          [],
        processDefinitionNameLike:
          filterParams.processDefinitionNameLike?.map(
            (process) => `"${process}"`,
          ) ?? [],
        startTime: filterParams.startTime,
        endTime: filterParams.endTime,
      };
      loadProcessesExecutions(formattedParams);
    },
    [search, processesType, loadProcessesExecutions, filterParams],
  );

  const handleDeleteChip = useCallback(
    (key: FilterParams, selectedChip?: string) => {
      if (
        (key === 'registradoPor' || key === 'processDefinitionNameLike') &&
        selectedChip
      ) {
        const filteredKey = filterParams[key]?.filter(
          (selected) => selected !== selectedChip,
        );

        const newFilterParams = {
          ...filterParams,
          [key]: filteredKey,
        };

        if (filteredKey && filteredKey?.length < 1) {
          delete newFilterParams[key];
        }
        setFilterParams(newFilterParams);
      } else if (key === 'startTime' || key === 'endTime') {
        const newFilterParams = filterParams;
        delete newFilterParams[key];

        setFilterParams({ ...newFilterParams });
      }
    },
    [filterParams],
  );

  const handleChangeRadio = useCallback(
    (event) => {
      const { value } = event.target;

      confirmAndNavigate(() => {
        if (searchInputRef?.current) searchInputRef.current.handleReset();
        setResetPage(true);
        setProcessesType(value);
        setFilterParams({});
        setCustomLimit(15);
      });
    },
    [confirmAndNavigate],
  );

  const handleChangePage = useCallback(
    (page: number, limit: number) => {
      setCustomLimit(limit);
      handleFilterTableExecutions({ page, limit });
    },
    [handleFilterTableExecutions],
  );

  const handleSubmitCancel = async (data: {
    [DATA_LIST_ID]: Array<{ value: string }>;
  }) => {
    const {
      [DATA_LIST_ID]: [cancellingReason],
    } = data;

    if (selectedProcess) {
      dispatch(
        cancelProcessExecutionsRequest(selectedProcess.id, {
          canceladoPorId: user.personId,
          canceladoPor: `${user.firstName} ${user.lastName}`,
          [DATA_LIST_ID]: cancellingReason.value,
        }),
      );
    }
  };

  const handleModalProcessDetail = useCallback(
    (process: IProcessesInstance | IProcessesHistory | null) => {
      setModalProcessDetail(!modalProcessDetail);
      setSelectedProcess(process);
    },
    [modalProcessDetail],
  );

  const handleModalCancelProcess = (
    process: IProcessesInstance | null | undefined,
  ) => {
    setModalCancelProcess(!modalCancelProcess);
    setSelectedProcess(process);
  };

  const handleCancel = (newLocation: Location): boolean => {
    if (canNavigate === true) {
      return true;
    }

    setLocation(newLocation);
    setConfirmationModal(true);
    return false;
  };

  useEffect(() => {
    if (processesType === 'inProgress') {
      setTotalProcesses(processesExecutionsInProgressTotal);
    }

    if (processesType === 'completed') {
      setTotalProcesses(processesExecutionsCompletedTotal);
    }

    if (processesType === 'deleted') {
      setTotalProcesses(processesExecutionsTerminatedTotal);
    }
  }, [
    processesExecutionsInProgressTotal,
    processesExecutionsCompletedTotal,
    processesExecutionsTerminatedTotal,
    processesType,
  ]);

  useEffect(() => {
    if (processCanceled) setModalCancelProcess(false);
  }, [processCanceled]);

  useEffect(() => {
    const params = {
      processesType,
      page: 1,
      limit: 15,
    };

    const countParams = {
      processesType,
    };

    loadProcessesExecutions(params);
    dispatch(getProcessesRequest());
    dispatch(getProcessesExecutionsCountRequest(countParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, processesType]);

  useEffect(() => {
    let profileKey;

    dispatch(getActivatedUsersRequest(profileKey));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    const params = {
      page: 1,
      limit: customLimit,
    };
    handleFilterTableExecutions(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, filterParams]);

  useEffect(() => {
    const canNavigate =
      !search && (!filterParams || Object.entries(filterParams).length < 1);

    setCanNavigate(canNavigate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterParams, search]);

  return (
    <Container>
      <PageTitle>Execuções</PageTitle>
      <Wrapper>
        <FormControl>
          <RadioGroup row>
            <FormControlLabel
              value="inProgress"
              control={<Radio />}
              label={`Em andamento (${processesExecutionsInProgressTotal})`}
              checked={processesType === 'inProgress'}
              onChange={(event) => handleChangeRadio(event)}
            />
            <FormControlLabel
              value="completed"
              control={<Radio />}
              label={`Concluídas (${processesExecutionsCompletedTotal})`}
              checked={processesType === 'completed'}
              onChange={(event) => handleChangeRadio(event)}
            />
            <FormControlLabel
              value="deleted"
              control={<Radio />}
              label={`Canceladas (${processesExecutionsTerminatedTotal})`}
              checked={processesType === 'deleted'}
              onChange={(event) => handleChangeRadio(event)}
            />
          </RadioGroup>
        </FormControl>
        <FilterWrapper>
          <InputSearchDebounce
            ref={searchInputRef}
            placeholder="Buscar uma solicitação ou execução"
            getSearch={(search) => setSearch(search)}
          />
          <FilterButton
            onClick={() => setModalProcessFilter(!modalProcessFilter)}
            type="button"
            disabled={loadingProcessesExecutions}
          >
            {loadingProcessesExecutions ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <>
                <BsFilter size={20} color="white" />
                Filtrar
              </>
            )}
          </FilterButton>
        </FilterWrapper>
      </Wrapper>

      <FilterChips
        filterParams={[
          {
            list: filterParams.registradoPor,
            label: (responsible) => responsible,
            onDelete: (responsible) =>
              handleDeleteChip('registradoPor', responsible),
          },
          {
            list: filterParams.processDefinitionNameLike,
            label: (process) => process,
            onDelete: (process) =>
              handleDeleteChip('processDefinitionNameLike', process),
          },
          {
            condition: !!filterParams.startTime,
            label: `${moment(filterParams.startTime?.[0]).format(
              'DD/MM/YYYY',
            )} - ${moment(filterParams.startTime?.[1]).format('DD/MM/YYYY')}`,
            onDelete: () => handleDeleteChip('startTime'),
          },
          {
            condition: !!filterParams.endTime,
            label: `${moment(filterParams.endTime?.[0]).format(
              'DD/MM/YYYY',
            )} - ${moment(filterParams.endTime?.[1]).format('DD/MM/YYYY')}`,
            onDelete: () => handleDeleteChip('endTime'),
          },
        ]}
        onClear={() => setFilterParams({})}
      />

      <Sidesheet
        title="Filtro"
        open={modalProcessFilter}
        modalState={() => setModalProcessFilter(false)}
        sidesheetSize="450px"
      >
        <Form
          ref={formTableRef}
          onSubmit={() => {}}
          style={{
            margin: '16px 16px 0 16px',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            gap: '16px',
          }}
        >
          <FilterContainer>
            <FilterTitle>Responsável por</FilterTitle>
            <Select
              closeMenuOnSelect={false}
              name="registradoPor"
              placeholder=""
              isClearable
              defaultValue={
                filterParams.registradoPor &&
                filterParams.registradoPor.length > 0
                  ? filterParams.registradoPor.map((registradoPor) => ({
                      label: registradoPor,
                      value: registradoPor,
                    }))
                  : null
              }
              options={
                activeUsers.length >= 1
                  ? activeUsers.map((activeUser) => {
                      return {
                        value: `${activeUser.firstName} ${activeUser.lastName}`,
                        label: `${activeUser.firstName} ${activeUser.lastName}`,
                      };
                    })
                  : []
              }
              isMulti
            />
          </FilterContainer>
          {processesType === 'inProgress' ? (
            <FilterContainer>
              <FilterTitle>Período de criação</FilterTitle>
              <DateRange
                name="startTime"
                hideCalendar
                defaultStartDate={
                  filterParams.startTime
                    ? moment(filterParams.startTime[0]).toDate()
                    : null
                }
                defaultEndDate={
                  filterParams.startTime
                    ? moment(filterParams.startTime[1]).toDate()
                    : null
                }
              />
            </FilterContainer>
          ) : (
            <FilterContainer>
              <FilterTitle>
                {processesType === 'completed'
                  ? 'Período de conclusão'
                  : 'Período de cancelamento'}
              </FilterTitle>
              <DateRange
                name="endTime"
                hideCalendar
                defaultStartDate={
                  filterParams.endTime
                    ? moment(filterParams.endTime[0], 'DD/MM/YYYY').toDate()
                    : null
                }
                defaultEndDate={
                  filterParams.endTime
                    ? moment(filterParams.endTime[1], 'DD/MM/YYYY').toDate()
                    : null
                }
              />
            </FilterContainer>
          )}
          <FilterContainer>
            <FilterTitle>Processo</FilterTitle>
            <Select
              closeMenuOnSelect={false}
              name="processDefinitionNameLike"
              placeholder=""
              isClearable
              defaultValue={
                filterParams.processDefinitionNameLike &&
                filterParams.processDefinitionNameLike.length > 0
                  ? filterParams.processDefinitionNameLike.map(
                      (processDefinition) => ({
                        label: processDefinition,
                        value: processDefinition,
                      }),
                    )
                  : null
              }
              options={processesDefinition?.map((process) => {
                return {
                  value: process.name,
                  label: process.name,
                };
              })}
              isMulti
            />
          </FilterContainer>
          <SubmitFilterButton
            type="button"
            onClick={() => {
              handleFilterParams();
              setModalProcessFilter(false);
            }}
          >
            Filtrar
          </SubmitFilterButton>
        </Form>
        <SidesheetCustomStyle />
      </Sidesheet>

      <PaginatedTable
        entities={processesExecutions}
        selectedEntities={
          showCheckBox ? [selectedProcesses, setSelectedProcesses] : undefined
        }
        loading={loadingProcessesExecutions}
        columns={[
          {
            header: 'Registrado em',
            value: (process) =>
              new Date(process.startTime).toLocaleDateString('pt-br', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                timeZone: 'utc',
                hour: 'numeric',
                minute: 'numeric',
              }),
          },
          {
            header: 'Registrado por',
            value: (process) => process.registradoPor,
          },
          {
            header: 'Processo',
            value: (process) => process.processDefinitionName,
          },
          {
            header: 'Solicitação',
            value: (process) => process.nomeSolicitacao,
          },
          {
            header: 'Execução',
            value: (process) => process.nomeExecucao,
          },
          {
            header:
              processesType === 'completed' ? 'Conclusão' : 'Cancelamento',
            value: (process) =>
              new Date(process.endTime).toLocaleDateString('pt-br', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                timeZone: 'utc',
                minute: 'numeric',
              }),
            condition: processesType !== 'inProgress',
          },
        ]}
        emptyTable={{
          title: `Nenhuma execução ${
            processesType === 'inProgress'
              ? 'em andamento'
              : 'concluída/cancelada'
          }`,
          description: `O sistema ainda não possui nenhuma execução ${
            processesType === 'inProgress'
              ? 'em andamento'
              : 'concluída/cancelada'
          }.\nContate o administrador.`,
        }}
        menu={[
          {
            label: 'Visualizar detalhes',
            Icon: MdRemoveRedEye,
            action: (process) => handleModalProcessDetail(process),
            permissions: [permissions.VIEW_DETAILS_REQUEST],
          },
          {
            label: loadingProcessCancelation
              ? 'Cancelando...'
              : 'Cancelar solicitação',
            Icon: MdDelete,
            action: (process) => handleModalCancelProcess(process),
            permissions: [permissions.CANCEL_REQUEST],
            disabled: loadingProcessCancelation,
            condition: () => processesType === 'inProgress',
          },
        ]}
        paginationProps={{
          total: totalProcesses,
          onChange: (page: number, limit: number) =>
            handleChangePage(page, limit),
          resetPage,
          onReset: (reseted) => setResetPage(reseted),
        }}
      />
      <ExecutionDetails
        executionInstanceId={selectedProcess?.id}
        open={modalProcessDetail}
        modalState={() => setModalProcessDetail(false)}
      />

      {modalCancelProcess && (
        <Modal
          title={`Cancelamento do processo: ${selectedProcess?.processDefinitionName}`}
          open={modalCancelProcess}
          modalState={(opened) => setModalCancelProcess(opened)}
          size="xs"
        >
          <Formik
            onSubmit={handleSubmitCancel}
            initialValues={{ [DATA_LIST_ID]: [] }}
            validationSchema={Yup.object().shape({
              [DATA_LIST_ID]: Yup.array().required(
                'A justificativa é obrigatória.',
              ),
            })}
            validateOnChange={false}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <DataListInput
                  key={DATA_LIST_ID}
                  fieldId={DATA_LIST_ID}
                  fieldName={DATA_LIST_ID}
                  fieldLabel="Justificativa do cancelamento"
                  dataListId={DATA_LIST_ID}
                />
                <CustomButton type="submit">
                  {loadingProcessCancelation ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    'Cancelar execução'
                  )}
                </CustomButton>
              </form>
            )}
          </Formik>
        </Modal>
      )}

      <Prompt
        when={!canNavigate}
        message={(location) => handleCancel(location)}
      />
    </Container>
  );
};

export default ProcessesExecutions;
